import React from 'react';
import paises from '../data/paisesNif.json';
const nomes=new Intl.DisplayNames(['pt-PT'],{type:'region'});
const opcoes=paises.filter(p=>p!=='PT').map(p=>({p,nome:nomes.of(p)})).sort((a,b)=>a.nome.localeCompare(b.nome,'pt'));
export default function IdentificacaoFiscal({pais='PT',nif='',onChange,disabled=false}){
 return <div style={{display:'grid',gap:8}}>
  <label style={{display:'flex',alignItems:'center',gap:6}}><input type="checkbox" style={{width:'auto',flexShrink:0}} disabled={disabled} checked={pais!=='PT'}
   onChange={e=>onChange({pais:e.target.checked?'':'PT',nif:''})}/> NIF estrangeiro</label>
  {pais!=='PT' && <label>País do fornecedor<select required disabled={disabled} value={pais}
   onChange={e=>onChange({pais:e.target.value,nif})}><option value="">Selecionar país</option>
   {opcoes.map(o=><option key={o.p} value={o.p}>{o.nome}</option>)}</select></label>}
  <label>{pais==='PT'?'NIF do fornecedor (Portugal)':'Identificação fiscal do fornecedor'}
   <input required disabled={disabled} type="text" inputMode={pais==='PT'?'numeric':'text'}
    maxLength={pais==='PT'?12:40} value={nif} onChange={e=>onChange({pais,nif:e.target.value.toUpperCase()})}
    autoCapitalize="characters" spellCheck={false}/></label>
 </div>;
}
